// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyB7oE7H2Xi9S3JfqRpb9U2zKC68AqW_W14",
  authDomain: "edtosoy-portfolio.firebaseapp.com",
  databaseURL: "https://edtosoy-portfolio.firebaseio.com",
  projectId: "edtosoy-portfolio",
  storageBucket: "edtosoy-portfolio.appspot.com",
  messagingSenderId: "790925924642",
  appId: "1:790925924642:web:a23a077361e39b4e306d7b",
  measurementId: "G-6HPNK92HKN",
};
// Initialize Firebase

firebase.initializeApp(firebaseConfig);
firebase.analytics();
